import { Link } from "react-router-dom";
import PageShell from "@/components/layout/PageShell";
import Seo from "@/components/seo/Seo";
import { waHref } from "@/lib/contact";
import { Home, Search, Mail, MessageCircle } from "lucide-react";

export default function NotFound() {
  return (
    <PageShell>
      <Seo
        title="Page not found | Fedari Inspection"
        description="The page you are looking for could not be found. Explore Fedari Inspection property snagging and handover inspection services across Dubai and the UAE."
        path="/404"
        noindex
      />
      <section className="wrap py-20 lg:py-28 text-center" data-testid="not-found">
        <p className="font-mono-jb text-blue tracking-widest text-sm mb-3">ERROR 404</p>
        <h1 className="text-[clamp(2.2rem,5vw,3.5rem)] tracking-[-0.03em] mb-4">This page could not be found</h1>
        <p className="text-bodytext max-w-[48ch] mx-auto mb-9">
          The page you were looking for may have moved or no longer exists. Here are some helpful places to go instead.
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          <Link to="/" data-testid="nf-home" className="inline-flex items-center gap-2 bg-blue text-white px-6 py-3.5 rounded-[10px] font-semibold hover:bg-blue-600 transition-colors"><Home size={16} /> Home</Link>
          <Link to="/property-snagging-dubai" data-testid="nf-services" className="inline-flex items-center gap-2 px-6 py-3.5 rounded-[10px] border border-line text-ink font-semibold hover:border-blue hover:text-blue transition-colors"><Search size={16} /> Services</Link>
          <Link to="/contact" data-testid="nf-contact" className="inline-flex items-center gap-2 px-6 py-3.5 rounded-[10px] border border-line text-ink font-semibold hover:border-blue hover:text-blue transition-colors"><Mail size={16} /> Contact</Link>
          <a href={waHref} target="_blank" rel="noopener noreferrer" data-testid="nf-whatsapp" className="inline-flex items-center gap-2 px-6 py-3.5 rounded-[10px] border border-line text-ink font-semibold hover:border-wa hover:text-wa transition-colors"><MessageCircle size={16} /> WhatsApp</a>
        </div>
      </section>
    </PageShell>
  );
}
